/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharacterslatin
 */
import Plugin from '@src/plugins/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Latin" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersLatin ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersLatin extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Latin', [
            {
                character: 'Ā',
                title: t('en')
            },
            {
                character: 'ā',
                title: t('eo')
            },
            {
                character: 'Ă',
                title: t('ep')
            },
            {
                character: 'ă',
                title: t('eq')
            },
            {
                character: 'Ą',
                title: t('er')
            },
            {
                character: 'ą',
                title: t('es')
            },
            {
                character: 'Ć',
                title: t('et')
            },
            {
                character: 'ć',
                title: t('eu')
            },
            {
                character: 'Ĉ',
                title: t('ev')
            },
            {
                character: 'ĉ',
                title: t('ew')
            },
            {
                character: 'Ċ',
                title: t('ex')
            },
            {
                character: 'ċ',
                title: t('ey')
            },
            {
                character: 'Č',
                title: t('ez')
            },
            {
                character: 'č',
                title: t('fa')
            },
            {
                character: 'Ď',
                title: t('fb')
            },
            {
                character: 'ď',
                title: t('fc')
            },
            {
                character: 'Đ',
                title: t('fd')
            },
            {
                character: 'đ',
                title: t('fe')
            },
            {
                character: 'Ē',
                title: t('ff')
            },
            {
                character: 'ē',
                title: t('fg')
            },
            {
                character: 'Ĕ',
                title: t('fh')
            },
            {
                character: 'ĕ',
                title: t('fi')
            },
            {
                character: 'Ė',
                title: t('fj')
            },
            {
                character: 'ė',
                title: t('fk')
            },
            {
                character: 'Ę',
                title: t('fl')
            },
            {
                character: 'ę',
                title: t('fm')
            },
            {
                character: 'Ě',
                title: t('fn')
            },
            {
                character: 'ě',
                title: t('fo')
            },
            {
                character: 'Ĝ',
                title: t('fp')
            },
            {
                character: 'ĝ',
                title: t('fq')
            },
            {
                character: 'Ğ',
                title: t('fr')
            },
            {
                character: 'ğ',
                title: t('fs')
            },
            {
                character: 'Ġ',
                title: t('ft')
            },
            {
                character: 'ġ',
                title: t('fu')
            },
            {
                character: 'Ģ',
                title: t('fv')
            },
            {
                character: 'ģ',
                title: t('fw')
            },
            {
                character: 'Ĥ',
                title: t('fx')
            },
            {
                character: 'ĥ',
                title: t('fy')
            },
            {
                character: 'Ħ',
                title: t('fz')
            },
            {
                character: 'ħ',
                title: t('ga')
            },
            {
                character: 'Ĩ',
                title: t('gb')
            },
            {
                character: 'ĩ',
                title: t('gc')
            },
            {
                character: 'Ī',
                title: t('gd')
            },
            {
                character: 'ī',
                title: t('ge')
            },
            {
                character: 'Ĭ',
                title: t('gf')
            },
            {
                character: 'ĭ',
                title: t('gg')
            },
            {
                character: 'Į',
                title: t('gh')
            },
            {
                character: 'į',
                title: t('gi')
            },
            {
                character: 'İ',
                title: t('gj')
            },
            {
                character: 'ı',
                title: t('gk')
            },
            {
                character: 'Ĳ',
                title: t('gl')
            },
            {
                character: 'ĳ',
                title: t('gm')
            },
            {
                character: 'Ĵ',
                title: t('gn')
            },
            {
                character: 'ĵ',
                title: t('go')
            },
            {
                character: 'Ķ',
                title: t('gp')
            },
            {
                character: 'ķ',
                title: t('gq')
            },
            {
                character: 'ĸ',
                title: t('gr')
            },
            {
                character: 'Ĺ',
                title: t('gs')
            },
            {
                character: 'ĺ',
                title: t('gt')
            },
            {
                character: 'Ļ',
                title: t('gu')
            },
            {
                character: 'ļ',
                title: t('gv')
            },
            {
                character: 'Ľ',
                title: t('gw')
            },
            {
                character: 'ľ',
                title: t('gx')
            },
            {
                character: 'Ŀ',
                title: t('gy')
            },
            {
                character: 'ŀ',
                title: t('gz')
            },
            {
                character: 'Ł',
                title: t('ha')
            },
            {
                character: 'ł',
                title: t('hb')
            },
            {
                character: 'Ń',
                title: t('hc')
            },
            {
                character: 'ń',
                title: t('hd')
            },
            {
                character: 'Ņ',
                title: t('he')
            },
            {
                character: 'ņ',
                title: t('hf')
            },
            {
                character: 'Ň',
                title: t('hg')
            },
            {
                character: 'ň',
                title: t('hh')
            },
            {
                character: 'ŉ',
                title: t('hi')
            },
            {
                character: 'Ŋ',
                title: t('hj')
            },
            {
                character: 'ŋ',
                title: t('hk')
            },
            {
                character: 'Ō',
                title: t('hl')
            },
            {
                character: 'ō',
                title: t('hm')
            },
            {
                character: 'Ŏ',
                title: t('hn')
            },
            {
                character: 'ŏ',
                title: t('ho')
            },
            {
                character: 'Ő',
                title: t('hp')
            },
            {
                character: 'ő',
                title: t('hq')
            },
            {
                character: 'Œ',
                title: t('hr')
            },
            {
                character: 'œ',
                title: t('hs')
            },
            {
                character: 'Ŕ',
                title: t('ht')
            },
            {
                character: 'ŕ',
                title: t('hu')
            },
            {
                character: 'Ŗ',
                title: t('hv')
            },
            {
                character: 'ŗ',
                title: t('hw')
            },
            {
                character: 'Ř',
                title: t('hx')
            },
            {
                character: 'ř',
                title: t('hy')
            },
            {
                character: 'Ś',
                title: t('hz')
            },
            {
                character: 'ś',
                title: t('ia')
            },
            {
                character: 'Ŝ',
                title: t('ib')
            },
            {
                character: 'ŝ',
                title: t('ic')
            },
            {
                character: 'Ş',
                title: t('id')
            },
            {
                character: 'ş',
                title: t('ie')
            },
            {
                character: 'Š',
                title: t('if')
            },
            {
                character: 'š',
                title: t('ig')
            },
            {
                character: 'Ţ',
                title: t('ih')
            },
            {
                character: 'ţ',
                title: t('ii')
            },
            {
                character: 'Ť',
                title: t('ij')
            },
            {
                character: 'ť',
                title: t('ik')
            },
            {
                character: 'Ŧ',
                title: t('il')
            },
            {
                character: 'ŧ',
                title: t('im')
            },
            {
                character: 'Ũ',
                title: t('in')
            },
            {
                character: 'ũ',
                title: t('io')
            },
            {
                character: 'Ū',
                title: t('ip')
            },
            {
                character: 'ū',
                title: t('iq')
            },
            {
                character: 'Ŭ',
                title: t('ir')
            },
            {
                character: 'ŭ',
                title: t('is')
            },
            {
                character: 'Ů',
                title: t('it')
            },
            {
                character: 'ů',
                title: t('iu')
            },
            {
                character: 'Ű',
                title: t('iv')
            },
            {
                character: 'ű',
                title: t('iw')
            },
            {
                character: 'Ų',
                title: t('ix')
            },
            {
                character: 'ų',
                title: t('iy')
            },
            {
                character: 'Ŵ',
                title: t('iz')
            },
            {
                character: 'ŵ',
                title: t('ja')
            },
            {
                character: 'Ŷ',
                title: t('jb')
            },
            {
                character: 'ŷ',
                title: t('jc')
            },
            {
                character: 'Ÿ',
                title: t('jd')
            },
            {
                character: 'Ź',
                title: t('je')
            },
            {
                character: 'ź',
                title: t('jf')
            },
            {
                character: 'Ż',
                title: t('jg')
            },
            {
                character: 'ż',
                title: t('jh')
            },
            {
                character: 'Ž',
                title: t('ji')
            },
            {
                character: 'ž',
                title: t('jj')
            },
            {
                character: 'ſ',
                title: t('jk')
            }
        ]);
    }
}